const placements = [
    "contactDetails_before",
    "contactDetails_after",
    "shippingAddress_before",
    "shippingAddress_after",
    "billingaddress_before",
    "billingaddress_after",
    "buttonDelivery_before",
    "buttonPlaceOrder_before",
];
export const isValidTarget = (target) => {
    const isValid = placements.includes(target);
    if (!isValid) {
        console.warn(`Warning: Order Attribute with target '${target}' is not a valid FormTarget.`);
    }
    return isValid;
};
//# sourceMappingURL=isValidTarget.js.map